export const tableColumnToExcelColumnMap = new Map([
    ['Production Plan ID', 'production plan id'],
    ['Year', 'year'],
    ['Planning Season', 'planning season'],
    ['Season', 'season'],
    ['Item Brand', 'item brand'],
    ['Business Unit', 'business unit'],
    ['Item Code', 'item code'],
    ['Item Name', 'item name'],
    ['Main Sample Code', 'main sample code'],
    ['Main Sample Code2', 'main sample code2'],
    ['Main Sample Name', 'main sample name'],
    ['Supplier Raw Material Code', 'supplier raw material code'],
    ['Supplier Raw Material Name', 'supplier raw material name'],
    ['Vendor Code', 'vendor code'],
    ['Vendor Name', 'vendor name'],
    ['Management Factory Code', 'management factory code'],
    ['Management Factory Name', 'management factory name'],
    ['Branch Factory Code', 'branch factory code'],
    ['Branch Factory Name', 'branch factory name'],
    ['Raw Material Supplier Code', 'raw material supplier code'],
    ['Raw Material Supplier Name', 'raw material supplier name'],
    ['Sewing Difficulty', 'sewing difficulty'],
    ['Department Code', 'department code'],
    ['Department Name', 'department name'],
    ['Class1 Code', 'class1 code'],
    ['Class1 Name', 'class1 name'],
    ['Column2', 'column2'],
    ['Column1', 'column1'],
    ['Production Plan Type Name', 'production plan type name'],
    ['Month Week Flag', 'month week flag'],
    ['Last Update Date', 'last update date'],
    ['Requested Wh Date', 'requested wh date'],
    ['Contracted Date', 'contracted date'],
    ['Contracted Exf', 'contracted exf'],
    ['Transport Method Name', 'transport method name'],
    ['Logistics Type Name', 'logistics type name'],
    ['Order Qty Pcs', 'order qty pcs'],
    ['Yarn Order Acceptance', 'yarn order acceptance'],
    ['Yarn Order Request Date', 'yarn order request date'],
    ['Yarn Order Answer Date', 'yarn order answer date'],
    ['Yarn Order Actual Date', 'yarn order actual date'],
    ['Yarn Order NO', 'yarn order no'],
    ['Yarn Actual Order Qty Pcs', 'yarn actual order qty pcs'],
    ['Yarn Update Date', 'yarn update date'],
    ['Fabric Order Acceptance', 'fabric order acceptance'],
    ['Fabric Order Request Date', 'fabric order request date'],
    ['Fabric Order Answer Date', 'fabric order answer date'],
    ['Fabric Order Actual Date', 'fabric order actual date'],
    ['Fabric Order NO', 'fabric order no'],
    ['Fabric Actual Order Qty Pcs', 'fabric actual order qty pcs'],
    ['Fabric Update Date', 'fabric update date'],
    ['Color Order Acceptance', 'color order acceptance'],
    ['Color Order Request Date', 'color order request date'],
    ['Color Order Answer Date', 'color order answer date'],
    ['Color Order Actual Date', 'color order actual date'],
    ['Color Order NO', 'color order no'],
    ['Color Actual Order Qty Pcs', 'color actual order qty pcs'],
    ['Color Update Date', 'color update date'],
    ['Trim Order Acceptance', 'trim order acceptance'],
    ['Trim Order Request Date', 'trim order request date'],
    ['Trim Order Answer Date', 'trim order answer date'],
    ['Trim Order Actual Date', 'trim order actual date'],
    ['Trim Order NO', 'trim order no'],
    ['Trim Actual Order Qty Pcs', 'trim actual order qty pcs'],
    ['Trim Update Date', 'trim update date'],
    ['PO Order Acceptance', 'po order acceptance'],
    ['PO Order Request Date', 'po order request date'],
    ['PO Order Answer Date', 'po order answer date'],
    ['PO Order Actual Date', 'po order actual date'],
    ['PO Order NO', 'po order no'],
    ['PO Actual Order Qty Pcs', 'po actual order qty pcs'],
    ['PO Update Date', 'po update date'],
    ['Order Qty Pcs (Old)', 'order qty pcs (old)'],
    ['Transport Method Name (Old)', 'transport method name (old)'],
    ['Logistics Type Name (Old)', 'logistics type name (old)'],
    ['Yarn Order Request Date (Old)', 'yarn order request date (old)'],
    ['Fabric Order Request Date (Old)', 'fabric order request date (old)'],
    ['Color Order Request Date (Old)', 'color order request date (old)'],
    ['Trim Order Request Date (Old)', 'trim order request date (old)'],
    ['PO Order Request Date (Old)', 'po order request date (old)'],
    ['Status', 'status'],
    ['Display Month WK', 'display month wk'],
    ['Display Month WK Column', 'display month wk column'],
    ['Group Cd', 'group cd'],
    ['2023/12;2023/12/04WK;2023/12/11WK;2023/12/18WK;2023/12/25WK;2024/01;2024/01/01WK;2024/01/08WK;2024/01/15WK;2024/01/22WK;2024/01/29WK;2024/02;2024/02/05WK;2024/02/12WK;2024/02/19WK;2024/02/26WK;2024/03;2024/03/04WK;2024/03/11WK;2024/03/18WK;2024/03/25WK;20', '2023/12;2023/12/04wk;2023/12/11wk;2023/12/18wk;2023/12/25wk;2024/01;2024/01/01wk;2024/01/08wk;2024/01/15wk;2024/01/22wk;2024/01/29wk;2024/02;2024/02/05wk;2024/02/12wk;2024/02/19wk;2024/02/26wk;2024/03;2024/03/04wk;2024/03/11wk;2024/03/18wk;2024/03/25wk;20'],
    ['Show Color Flag', 'show color flag'],
    ['Order Qty Coeff', 'order qty coeff'],
    ['Factory Comment', 'factory comment'],
    ['Factory Comment Update Date', 'factory comment update date'],
    ['FR Fabric Code', 'fr fabric code'],
    ['FR Fabric Name', 'fr fabric name'],
    ['Ph1 (First) Discrimination Flag (Old)', 'ph1 (first) discrimination flag (old)'],
    ['Ph1 (First) Discrimination Flag', 'ph1 (first) discrimination flag'],
    ['Order Timing Display Value (Old)', 'order timing display value (old)'],
    ['Order Timing Display Value', 'order timing display value'],
    ['Express Line Flag (Old)', 'express line flag (old)'],
    ['Express Line Flag', 'express line flag'],
    ['Manual Lock Flag (Old)', 'manual lock flag (old)'],
    ['Manual Lock Flag', 'manual lock flag'],
    ['Ph1 (First) Discrimination Flag (Now)', 'ph1 (first) discrimination flag (now)'],
    ['Order Timing Display Value (Now)', 'order timing display value (now)'],
    ['Express Line Flag (Now)', 'express line flag (now)'],
    ['Manual Lock Flag (Now)', 'manual lock flag (now)'],
    ['Requested Wh Date(Old)', 'requested wh date(old)'],
    ['EXF', 'exf'],
    ['(Color) Recommend', '(color) recommend'],
    ['(Trim) Recommend', '(trim) recommend'],
    ['(PO)Recommend', '(po)recommend'],
    ['BD-EXF DL Setting LT(Before Cal)', 'bd-exf dl setting lt(before cal)'],
    ['PO-EXF DL Setting LT(Before Cal)', 'po-exf dl setting lt(before cal)'],
    ['Material Supplier Holiday Excluding', 'material supplier holiday excluding'],
    ['Sewing FTY Holiday Excluding', 'sewing fty holiday excluding'],
    ['BD-EXF DL Setting LT', 'bd-exf dl setting lt'],
    ['PO-EXF DL Setting LT', 'po-exf dl setting lt'],
    ['BD-EXF Registered LT', 'bd-exf registered lt'],
    ['PO-EXF Registered LT', 'po-exf registered lt'],
    ['BD-EXF(total) Abnormal LT', 'bd-exf(total) abnormal lt'],
    ['PO-EXF(total) Abnormal LT', 'po-exf(total) abnormal lt'],
    ['Abnormal LT Reason BD1', 'abnormal lt reason bd1'],
    ['Abnormal LT Reason BD2', 'abnormal lt reason bd2'],
    ['Abnormal LT Reason BD3', 'abnormal lt reason bd3'],
    ['Abnormal LT Reason BD4', 'abnormal lt reason bd4'],
    ['Abnormal LT Reason BD5', 'abnormal lt reason bd5'],
    ['Abnormal LT BD1', 'abnormal lt bd1'],
    ['Abnormal LT BD2', 'abnormal lt bd2'],
    ['Abnormal LT BD3', 'abnormal lt bd3'],
    ['Abnormal LT BD4', 'abnormal lt bd4'],
    ['Abnormal LT BD5', 'abnormal lt bd5'],
    ['Abnormal LT Reason PO1', 'abnormal lt reason po1'],
    ['Abnormal LT Reason PO2', 'abnormal lt reason po2'],
    ['Abnormal LT Reason PO3', 'abnormal lt reason po3'],
    ['Abnormal LT Reason PO4', 'abnormal lt reason po4'],
    ['Abnormal LT Reason PO5', 'abnormal lt reason po5'],
    ['Abnormal LT PO1', 'abnormal lt po1'],
    ['Abnormal LT PO2', 'abnormal lt po2'],
    ['Abnormal LT PO3', 'abnormal lt po3'],
    ['Abnormal LT PO4', 'abnormal lt po4'],
    ['Abnormal LT PO5', 'abnormal lt po5'],
    ['fab~exf', 'fab~exf'],
    ['BD~exf', 'bd~exf'],
    ['PO~exf', 'po~exf'],
    ['fab~exf2', 'fab~exf2'],
    ['BD~exf3', 'bd~exf3'],
    ['PO~exf4', 'po~exf4'],
    ['Remarks', 'remarks'],
    ['Action Needed', 'action needed'],
    ['Possible exf', 'possible exf'],
    ['Possible WH', 'possible wh'],
    ['STOP & GO', 'stop & go'],
    ['SAM', 'sam'],
    ['Minutes', 'minutes'],
    ['In Keisu', 'in keisu'],
    ['Fabric consumption', 'fabric consumption'],
    ['Req fabric in kgs', 'req fabric in kgs'],
    ['Fabric lead time', 'fabric lead time'],
    ['Trim lead time', 'trim lead time'],
    ['PO Lead time', 'po lead time'],
    ['Fabric', 'fabric'],
    ['Trim', 'trim'],
    ['PO', 'po'],
    ['Fabric DL on Tuesdays', 'fabric dl on tuesdays'],
    ['Trim DL on Tuesdays', 'trim dl on tuesdays'],
    ['PO DL on Tuesdays', 'po dl on tuesdays'],
    ['Today', 'today'],
    ['Fabric answer\r\nDays left from (today)', 'fabric answer days left from (today)'],
    ['Trim answer\r\nDays left from (today)2', 'trim answer days left from (today)2'],
    ['PO answer\r\nDays left from (today)3', 'po answer days left from (today)3']
]);


export const dateColumnHeaders = ['exf date', 'requested wh date', 'contracted date', 'fabric order request date', 'fabric order answer date', 'fabric order actual date', 'trim order request date', 'trim order answer date', 'trim order actual date', 'po order request date', 'po order answer date', 'po order actual date', 'yarn order request date', 'yarn order answer date', 'yarn order actual date','color update date','display month wk','factory comment update date','exf',
'fabric update date', 'yarn update date', 'trim update date', 'po update date',
'last update date'];

export const numericColumnHeaders = ['sewing difficulty','order qty pcs','yarn actual order qty pcs','fabric actual order qty pcs','color actual order qty pcs','trim actual order qty pcs','po actual order qty pcs','order qty pcs (old)','order qty coeff','bd-exf dl setting lt(before cal)','po-exf dl setting lt(before cal)','material supplier holiday excluding','sewing fty holiday excluding','bd-exf dl setting lt','po-exf dl setting lt','bd-exf registered lt','po-exf registered lt','bd-exf(total) abnormal lt','po-exf(total) abnormal lt'];


export const transportationMethodToLeadTime = Object.freeze({
    ship: 7,
    air: 15
})

export const transportationMethodToReferenceColumn = Object.freeze({
    ship: 'contracted date',
    air: 'requested wh date'
})


class ExcelUploadValidator {
    type: string;
    maxLength: number;
    strictTypeCheck: boolean;
    required: boolean;
    label: string
}

export const excelUploadValidatorMap: Map<string, ExcelUploadValidator> = new Map([
    ['production plan id', { type: 'string', strictTypeCheck: true, maxLength: 15, required: true, label: 'production plan id' }],
    ['main sample code2', { type: 'string', strictTypeCheck: false, maxLength: 15, required: true, label: 'main sample code2' }],
    ['year', { type: 'string', strictTypeCheck: false, maxLength: 4, required: true, label: 'year' }],
    ['planning season', { type: 'string', strictTypeCheck: false, maxLength: 8, required: true, label: 'Planning Season' }],
    ['production plan type name', { type: 'string', strictTypeCheck: true, maxLength: 30, required: true, label: 'Production Plan Type Name' }],
    ['item name', { type: 'string', strictTypeCheck: true, maxLength: 30, required: true, label: 'Item Name' }]
]);

export const dtoToExcelColumMap: Map<string, string> = new Map([
    ['productionPlanId', 'production plan id'],
    ['country', ''],
    ['season', ''],
    ['businessUnit', 'business unit'],
    ['styleNo', ''],
    ['phase', ''],
    ['exfDate', 'exf date'],
    ['whDate', 'requested wh date'],
    ['contractDate', 'contracted date'],
    ['fabRequestDate', 'fabric order request date'],
    ['fabricAnswerDate', 'fabric order answer date'],
    ['fabricActualDate', 'fabric order actual date'],
    ['trimRequestDate', 'trim order request date'],
    ['trimAnswerDate', 'trim order answer date'],
    ['trimActualDate', 'trim order actual date'],
    ['poRequestDate', 'po order request date'],
    ['poAnswerDate', 'po order answer date'],
    ['poActualDate', 'po order actual date'],
    ['fabOqyt', 'fabric actual order qty pcs'],
    ['trimOqty', 'trim actual order qty pcs'],
    ['poOqty', 'po actual order qty pcs'],
    ['sam', 'minutes'],
    ['keisu', 'in keisu'],
    ['samMaster', 'sam'],
    ['fabBodyConsumption', 'fabric body consumption'],
    ['fabBodyRequirement', 'fabric requirement body'],
    ['fabConsumptionWithTrims', 'fabric consumption with trims'],
    ['fabRequirementWithTrims', 'fabric requirement with trims'],
    ['itemName', 'item name'],
    ['mainSampleCode', 'main sample code'],
    ["productionPlanTypeName", "production plan type name"],
    ["trimOrderNo", "trim order no"],
    ["fabricOrderNo", "fabric order no"],
    ["poOrderNo", "po order no"],
    ["productionMonth", "production month"]
]);

export const newMap = new Map([
    ["production plan id", "productionPlanId"],
    ["year", "year"],
    ["planning season", "planningSeason"],
    ["season", "season"],
    ["item brand", "itemBrand"],
    ["business unit", "businessUnit"],
    ["item code", "itemCode"],
    ["item name", "itemName"],
    ["main sample code", "mainSampleCode"],
    ["main sample code2", "mainSampleCode2"],
    ["main sample name", "mainSampleName"],
    ["supplier raw material code", "supplierRawMateriaCode"],
    ["supplier raw material name", "supplierRawMateriaName"],
    ["vendor code", "vendorCode"],
    ["vendor name", "vendorName"],
    ["management factory code", "managementFactoryCode"],
    ["management factory name", "managementFactoryName"],
    ["branch factory code", "branchFactoryCode"],
    ["branch factory name", "branchFactoryName"],
    ["raw material supplier code", "rawMaterialSupplierCode"],
    ["raw material supplier name", "rawMaterialSupplierName"],
    ["sewing difficulty", "sewingDifficulty"],
    ["department code", "departmentCode"],
    ["department name", "departmentName"],
    ["class1 code", "class1code"],
    ["class1 name", "class1name"],
    ["column2", "column2"],
    ["column1", "column1"],
    ["production plan type name", "productionPlanTypeName"],
    ["month week flag", "monthWeekFlag"],
    ["last update date", "lastUpdateDate"],
    ["requested wh date", "requestedWHDate"],
    ["contracted date", "contractedDate"],
    ["contracted exf", "contractedExf"],
    ["transport method name", "transportMethodName"],
    ["logistics type name", "logisticsTypeName"],
    ["order qty pcs", "orderQtyPcs"],
    ["yarn order acceptance", "yarnOrderAcceptance"],
    ["yarn order request date", "yarnOrderRequestDate"],
    ["yarn order answer date", "yarnOrderAnswerDate"],
    ["yarn order actual date", "yarnOrderActualDate"],
    ["yarn order no", "yarnOrderNo"],
    ["yarn actual order qty pcs", "yarnActualOrderQtyPcs"],
    ["yarn update date", "yarnUpdateDate"],
    ["fabric order acceptance", "fabricOrderAcceptance"],
    ["fabric order request date", "fabricOrderRequestDate"],
    ["fabric order answer date", "fabricOrderAnswerDate"],
    ["fabric order actual date", "fabricOrderActualDate"],
    ["fabric order no", "fabricOrderNo"],
    ["fabric actual order qty pcs", "fabricActualOrderQtyPcs"],
    ["fabric update date", "fabricUpdateDate"],
    ["color order acceptance", "colorOrderAcceptance"],
    ["color order request date", "colorOrderRequestDate"],
    ["color order answer date", "colorOrderAnswerDate"],
    ["color order actual date", "colorOrderActualDate"],
    ["color order no", "colorOrderNo"],
    ["color actual order qty pcs", "colorActualOrderQtyPcs"],
    ["color update date", "colorUpdateDate"],
    ["trim order acceptance", "trimOrderAcceptance"],
    ["trim order request date", "trimOrderRequestDate"],
    ["trim order answer date", "trimOrderAnswerDate"],
    ["trim order actual date", "trimOrderActualDate"],
    ["trim order no", "trimOrderNo"],
    ["trim actual order qty pcs", "trimActualOrderQtyPcs"],
    ["trim update date", "trimUpdateDate"],
    ["po order acceptance", "poOrderAcceptance"],
    ["po order request date", "poOrderRequestDate"],
    ["po order answer date", "poOrderAnswerDate"],
    ["po order actual date", "poOrderActualDate"],
    ["po order no", "poOrderNo"],
    ["po actual order qty pcs", "poActualOrderQtyPcs"],
    ["po update date", "poUpdateDate"],
    ["order qty pcs (old)", "orderQtyPcs(old)"],
    ["transport method name (old)", "transportMethodName(old)"],
    ["logistics type name (old)", "logisticsTypeName(old)"],
    ["yarn order request date (old)", "yarnOrderRequestDate(old)"],
    ["fabric order request date (old)", "fabricOrderRequestDate(old)"],
    ["color order request date (old)", "colorOrderRequestDate(old)"],
    ["trim order request date (old)", "trimOrderRequestDate(old)"],
    ["po order request date (old)", "poOrderRequestDate(old)"],
    ["status", "status"],
    ["display month wk", "displayMonthWk"],
    ["display month wk column", "displayMonthWkColumn"],
    ["group cd", "groupCd"],
    ["show color flag", "showColorFlag"],
    ["order qty coeff", "orderQtyCoEff"],
    ["factory comment", "factoryComment"],
    ["factory comment update date", "factoryCommentUpdateDate"],
    ["fr fabric code", "frFabricCode"],
    ["fr fabric name", "frFabricName"],
    ["ph1 (first) discrimination flag (old)", "ph1(first)discriminationFlag(old)"],
    ["ph1 (first) discrimination flag", "ph1(first)discriminationFlag(now)"],
    ["order timing display value (old)", "ph1(first)discriminationFlag"],
    ["order timing display value", "orderTimingDisplayValue(old)"],
    ["express line flag (old)", "orderTimingDisplayValue(now)"],
    ["express line flag", "orderTimingDisplayValue"],
    ["manual lock flag (old)", "expressLineFlag(old)"],
    ["manual lock flag", "expressLineFlag"],
    ["ph1 (first) discrimination flag (now)", "manualLockFlag(old)"],
    ["order timing display value (now)", "manualLockFlag"],
    ["express line flag (now)", "expressLineFlag(now)"],
    ["manual lock flag (now)", "manualLockFlag(now)"],
    ["requested wh date(old)", "requestedWHDate(old)"],
    ["exf", "exf"],
    ["(color) recommend", "(color)recommend"],
    ["(trim) recommend", "(trim)recommend"],
    ["(po)recommend", "(po)recommend"],
    ["bd-exf dl setting lt(before cal)", "bd-exFdlSettingLt(beforecal)"],
    ["po-exf dl setting lt(before cal)", "po-exFdlSettingLt(beforecal)"],
    ["material supplier holiday excluding", "materialSupplierHolidayExcluding"],
    ["sewing fty holiday excluding", "sewingFtyHolidayExcluding"],
    ["bd-exf dl setting lt", "bd-exFdlSettingLt"],
    ["po-exf dl setting lt", "po-exFdlSettingLt"],
    ["bd-exf registered lt", "bd-exfRegisterEdLt"],
    ["po-exf registered lt", "po-exfRegisterEdLt"],
    ["bd-exf(total) abnormal lt", "bd-exf(total)abnormalLt"],
    ["po-exf(total) abnormal lt", "po-exf(total)abnormalLt"],
    ["abnormal lt reason bd1", "abnormalLtReasonBd1"],
    ["abnormal lt reason bd2", "abnormalLtReasonBd2"],
    ["abnormal lt reason bd3", "abnormalLtReasonBd3"],
    ["abnormal lt reason bd4", "abnormalLtReasonBd4"],
    ["abnormal lt reason bd5", "abnormalLtReasonBd5"],
    ["abnormal lt bd1", "abnormalLtBd1"],
    ["abnormal lt bd2", "abnormalLtBd2"],
    ["abnormal lt bd3", "abnormalLtBd3"],
    ["abnormal lt bd4", "abnormalLtBd4"],
    ["abnormal lt bd5", "abnormalLtBd5"],
    ["abnormal lt reason po1", "abnormalLtReasonPo1"],
    ["abnormal lt reason po2", "abnormalLtReasonPo2"],
    ["abnormal lt reason po3", "abnormalLtReasonPo3"],
    ["abnormal lt reason po4", "abnormalLtReasonPo4"],
    ["abnormal lt reason po5", "abnormalLtReasonPo5"],
    ["abnormal lt po1", "abnormalLtPo1"],
    ["abnormal lt po2", "abnormalLtPo2"],
    ["abnormal lt po3", "abnormalLtPo3"],
    ["abnormal lt po4", "abnormalLtPo4"],
    ["abnormal lt po5", "abnormalLtPo5"],
    ["fab~exf", "fab~exf"],
    ["bd~exf", "bd~exf"],
    ["po~exf", "po~exf"],
    ["fab~exf2", "fab~exf2"],
    ["bd~exf3", "bd~exf3"],
    ["po~exf4", "po~exf4"],
    ["remarks", "remarks"],
    ["action needed", "actionNeeded"],
    ["possible exf", "possibleExf"],
    ["possible wh", "possibleWh"],
    ["stop & go", "stop&go"],
    ["sam", "sam"],
    ["minutes", "minutes"],
    ["in keisu", "inkeisu"],
    ["fabric consumption", "fabricConsumption"],
    ["req fabric in kgs", "reqFabricInKgs"],
    ["fabric lead time", "fabricLeadTime"],
    ["trim lead time", "trimLeadTime"],
    ["po lead time", "poLeadTime"],
    ["fabric", "fabric"],
    ["trim", "trim"],
    ["po", "po"],
    ["fabric dl on tuesdays", "fabricDlOnTuesdays"],
    ["trim dl on tuesdays", "trimDlOnTuesdays"],
    ["po dl on tuesdays", "poDlOnTuesdays"],
    ["today", "today"],
    ["fabric answer\r\ndays left from (today)", "fabricAnswerDaysLeftFrom(today)"],
    ["trim answer\r\ndays left from (today)2", "trimAnswerDaysLeftFrom(today)2"],
    ["po answer\r\ndays left from (today)3", "poAnswerDaysLeftFrom(today)3"],
    ["sample code", "sampleCode"],
    ["helper", "helper"],
    ["ph", "ph"],
    ["body", "body"],
    ["sleeve", "sleeve"],
    ["rib", "rib"],
    ["rib - nk & bttm", "rib-nk&btTm"],
    ["s/j", "s/j"],
    ["fleece", "fleece"],
    ["total", "total"],
    ["body only in kgs", "bodyOnlyInKgs"],
    ["con on body", "conOnBody"],
    ["trim order no", "trimOrderNo",],
    ["fabric order no", "fabricOrderNo"],
    ["po order no", "poOrderNo"],
    ["production month", "productionMonth"]
]);

export const masterExcelToTableColumnMap = new Map([
    ["item name", "itemName"],
    ["season", "season"],
    ["helper", "helper"],
    ["main sample code2", "mainSampleCode2"],
    ["production plan type name", "productionPlanTypeName"],
    ["fabric lead time", "fabricLeadTime"],
    ["trim lead time", "trimLeadTime"],
    ["po lead time", "poLeadTime"],
    ["sam", "sam"],
    ["keisu", "keisu"],
    ["body", "body"],
    ["sleeve", "sleeve"],
    ["rib", "rib"],
    ["s/j", "sJ"],
    ["fleece", "fleece"],
    ["total", "total"]
]);

export const masterExcelUploadValidatorMap: Map<string, ExcelUploadValidator> = new Map([
    ['item name', { type: 'string', strictTypeCheck: false, maxLength: 15, required: false, label: 'Item Name' }],
    ['season', { type: 'string', strictTypeCheck: false, maxLength: 8, required: false, label: 'Season' }],
    ['helper', { type: 'string', strictTypeCheck: false, maxLength: 8, required: false, label: 'helper' }],
    ['main sample code2', { type: 'string', strictTypeCheck: false, maxLength: 15, required: false, label: 'main sample code2' }],
    ['production plan type name', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'Production Plan Type Name' }],
    ['fabric lead time', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'Fabric Lead Time' }],
    ['trim lead time', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'Trim Lead Time' }],
    ['po lead time', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'PO Lead Time' }],
    ['sam', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'sam' }],
    ['keisu', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'keisu' }],
    ['body', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'body' }],
    ['sleeve', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'sleeve' }],
    ['rib', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'rib' }],
    ['rib - nk & bttm', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'rib - nk & bttm' }],
    ['s/j', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 's/j' }],
    ['fleece', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'fleece' }],
    ['total', { type: 'string', strictTypeCheck: false, maxLength: 30, required: false, label: 'total' }]
]);


export const PaRequestToTableColumnMap = new Map([
    ["Dept", "dept"],
    ["Year", "year"],
    ["Ssn", "ssn"],
    ["Item Code", "itemCode"],
    ["Item Name", "itemName"],
    ["Bu Cd", "buCd"],
    ["Biz", "biz"],
    ["Main Sample Cd", "mainSampleCd"],
    ["Management Factory Cd", "managementFactoryCd"],
    ["Management Factory", "managementFactory"],
    ["Branch Factory Cd", "branchFactoryCd"],
    ["Branch Factory", "branchFactory"],
    ["Vendor Cd", "vendorCd"],
    ["Vendor", "vendor"],
    ["Original Order Process Target", "originalOrderProcessTarget"],
    ["Original Order Process Done", "originalOrderProcessDone"],
    ["Original Ph", "originalPh"],
    ["Original Publish", "originalPublish"],
    ["Original TrnsptMthd", "originalTrnsptMthd"],
    ["Original WH", "originalWh"],
    ["Original DL", "originalDl"],
    ["Original Plan Qty", "originalPlanQty"],
    ["Original Update Date", "originalUpdateDate"],
    ["Original Order Plan Number", "originalOrderPlanNumber"],
    ["Request ID", "requestId"],
    ["Request Classification", "requestClassification"],
    ["Request Type", "requestType"],
    ["Request Color", "requestColor"],
    ["Request WH", "requestWh"],
    ["Request DL", "requestDl"],
    ["Request Plan Qty", "requestPlanQty"],
    ["Request TrnsptMthd", "requestTrnsptMthd"],
    ["Request Request Date(JST)", "requestRequestDateJst"],
    ["Request Request User", "requestRequestUser"],
    ["Request Comment", "requestComment"],
    ["Request Sales Rank of Biz at Last Week", "requestSalesRankOfBizAtLastWeek"],
    ["Request Sales Rank of Div. at Last Week", "requestSalesRankOfDivAtLastWeek"],
    ["Answer DL(JST)", "answerDlJst"],
    ["Factory Answer AgrFlg", "factoryAnswerAgrFlg"],
    ["Factory Answer Jdg Rslt", "factoryAnswerJdgRslt"],
    ["Factory Answer Psbl PH", "factoryAnswerPsblPh"],
    ["Factory Answer PsblWH(Ship)", "factoryAnswerPsblWhShip"],
    ["Factory Answer PsblWH(Air)", "factoryAnswerPsblWhAir"],
    ["Factory Answer Min Qty", "factoryAnswerMinQty"],
    ["Factory Answer Psbl Qty", "factoryAnswerPsblQty"],
    ["Factory Answer Yarn DL", "factoryAnswerYarnDl"],
    ["Factory Answer Fabric DL", "factoryAnswerFabricDl"],
    ["Factory Answer Color DL", "factoryAnswerColorDl"],
    ["Factory Answer Trim DL", "factoryAnswerTrimDl"],
    ["Factory Answer PO DL", "factoryAnswerPoDl"],
    ["Factory Answer EXF", "factoryAnswerExf"],
    ["Factory Answer BD-EXF", "factoryAnswerBdExf"],
    ["Factory Answer PO-EXF", "factoryAnswerPoExf"],
    ["Factory Answer Prd Month", "factoryAnswerPrdMonth"],
    ["Factory Answer NG Reason1", "factoryAnswerNgReason1"],
    ["Factory Answer NG Reason2", "factoryAnswerNgReason2"],
    ["Factory Answer Free Comment", "factoryAnswerFreeComment"],
    ["Factory Answer Answer User", "factoryAnswerAnswerUser"],
    ["Factory Answer Answer Date", "factoryAnswerAnswerDate"],
    ["Order Decision Decision", "orderDecisionDecision"],
    ["Order Decision Order Qty", "orderDecisionOrderQty"],
    ["Order Decision Air Use", "orderDecisionAirUse"],
    ["DL Yarn Order Qty", "dlYarnOrderQty"],
    ["DL Yarn Order Number", "dlYarnOrderNumber"],
    ["DL Yarn Plan", "dlYarnPlan"],
    ["DL Yarn Actual", "dlYarnActual"],
    ["DL Fabric Order Qty", "dlFabricOrderQty"],
    ["DL Fabric Order Number", "dlFabricOrderNumber"],
    ["DL Fabric Plan", "dlFabricPlan"],
    ["DL Fabric Actual", "dlFabricActual"],
    ["DL Color Order Qty", "dlColorOrderQty"],
    ["DL Color Order Number", "dlColorOrderNumber"],
    ["DL Color Plan", "dlColorPlan"],
    ["DL Color Actual", "dlColorActual"],
    ["DL Trim Order Qty", "dlTrimOrderQty"],
    ["DL Trim Order Number", "dlTrimOrderNumber"],
    ["DL Trim Plan", "dlTrimPlan"],
    ["DL Trim Actual", "dlTrimActual"],
    ["DL PO Order Qty", "dlPoOrderQty"],
    ["DL PO Order Number", "dlPoOrderNumber"],
    ["DL PO Plan", "dlPoPlan"],
    ["DL PO Actual", "dlPoActual"],
    ["Factory Answer Jdg Rslt(First time)", "factoryAnswerJdgRsltFirstTime"],
    ["Factory Answer NG Reason1(First time)", "factoryAnswerNgReason1FirstTime"],
    ["Factory Answer NG Reason2(First time)", "factoryAnswerNgReason2FirstTime"],
    ["Factory Answer Free Comment(First time)", "factoryAnswerFreeCommentFirstTime"]
])


export const PARequestListUploadValidatorMap: Map<string, ExcelUploadValidator> = new Map([
    ["Dept", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Dept" }],
    ["Year", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Year" }],
    ["Ssn", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Ssn" }],
    ["Item Code", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Item Code" }],
    ["Item Name", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Item Name" }],
    ["Bu Cd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Bu Cd" }],
    ["Biz", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Biz" }],
    ["Main Sample Cd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Main Sample Cd" }],
    ["Management Factory Cd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Management Factory Cd" }],
    ["Management Factory", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Management Factory" }],
    ["Branch Factory Cd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Branch Factory Cd" }],
    ["Branch Factory", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Branch Factory" }],
    ["Vendor Cd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Vendor Cd" }],
    ["Vendor", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Vendor" }],
    ["Original Order Process Target", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Order Process Target" }],
    ["Original Order Process Done", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Order Process Done" }],
    ["Original Ph", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Ph" }],
    ["Original Publish", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Publish" }],
    ["Original TrnsptMthd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original TrnsptMthd" }],
    ["Original WH", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original WH" }],
    ["Original DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original DL" }],
    ["Original Plan Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Plan Qty" }],
    ["Original Update Date", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Update Date" }],
    ["Original Order Plan Number", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Original Order Plan Number" }],
    ["Request ID", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request ID" }],
    ["Request Classification", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Classification" }],
    ["Request Type", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Type" }],
    ["Request Color", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Color" }],
    ["Request WH", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request WH" }],
    ["Request DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request DL" }],
    ["Request Plan Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Plan Qty" }],
    ["Request TrnsptMthd", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request TrnsptMthd" }],
    ["Request Request Date(JST)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Request Date(JST)" }],
    ["Request Request User", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Request User" }],
    ["Request Comment", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Comment" }],
    ["Request Sales Rank of Biz at Last Week", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Sales Rank of Biz at Last Week" }],
    ["Request Sales Rank of Div. at Last Week", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Request Sales Rank of Div. at Last Week" }],
    ["Answer DL(JST)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Answer DL(JST)" }],
    ["Factory Answer AgrFlg", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer AgrFlg" }],
    ["Factory Answer Jdg Rslt", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Jdg Rslt" }],
    ["Factory Answer Psbl PH", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Psbl PH" }],
    ["Factory Answer PsblWH(Ship)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer PsblWH(Ship)" }],
    ["Factory Answer PsblWH(Air)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer PsblWH(Air)" }],
    ["Factory Answer Min Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Min Qty" }],
    ["Factory Answer Psbl Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Psbl Qty" }],
    ["Factory Answer Yarn DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Yarn DL" }],
    ["Factory Answer Fabric DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Fabric DL" }],
    ["Factory Answer Color DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Color DL" }],
    ["Factory Answer Trim DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Trim DL" }],
    ["Factory Answer PO DL", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer PO DL" }],
    ["Factory Answer EXF", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer EXF" }],
    ["Factory Answer BD-EXF", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer BD-EXF" }],
    ["Factory Answer PO-EXF", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer PO-EXF" }],
    ["Factory Answer Prd Month", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Prd Month" }],
    ["Factory Answer NG Reason1", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer NG Reason1" }],
    ["Factory Answer NG Reason2", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer NG Reason2" }],
    ["Factory Answer Free Comment", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Free Comment" }],
    ["Factory Answer Answer User", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Answer User" }],
    ["Factory Answer Answer Date", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Answer Date" }],
    ["Order Decision Decision", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Order Decision Decision" }],
    ["Order Decision Order Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Order Decision Order Qty" }],
    ["Order Decision Air Use", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Order Decision Air Use" }],
    ["DL Yarn Order Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Yarn Order Qty" }],
    ["DL Yarn Order Number", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Yarn Order Number" }],
    ["DL Yarn Plan", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Yarn Plan" }],
    ["DL Yarn Actual", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Yarn Actual" }],
    ["DL Fabric Order Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Fabric Order Qty" }],
    ["DL Fabric Order Number", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Fabric Order Number" }],
    ["DL Fabric Plan", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Fabric Plan" }],
    ["DL Fabric Actual", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Fabric Actual" }],
    ["DL Color Order Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Color Order Qty" }],
    ["DL Color Order Number", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Color Order Number" }],
    ["DL Color Plan", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Color Plan" }],
    ["DL Color Actual", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Color Actual" }],
    ["DL Trim Order Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Trim Order Qty" }],
    ["DL Trim Order Number", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Trim Order Number" }],
    ["DL Trim Plan", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Trim Plan" }],
    ["DL Trim Actual", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL Trim Actual" }],
    ["DL PO Order Qty", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL PO Order Qty" }],
    ["DL PO Order Number", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL PO Order Number" }],
    ["DL PO Plan", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL PO Plan" }],
    ["DL PO Actual", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "DL PO Actual" }],
    ["Factory Answer Jdg Rslt(First time)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Jdg Rslt(First time)" }],
    ["Factory Answer NG Reason1(First time)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer NG Reason1(First time)" }],
    ["Factory Answer NG Reason2(First time)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer NG Reason2(First time)" }],
    ["Factory Answer Free Comment(First time)", { type: "string", strictTypeCheck: false, maxLength: 30, required: false, label: "Factory Answer Free Comment(First time)" }],

])